<template>
    <div :class="[
        'p-4 rounded-lg flex items-center gap-4 mb-6 border',
        bgClass,
        borderClass,
    ]">
        <AppIcon :icon="icon" class="w-8 h-8" :class="iconClass" />
        <p class="text-sm font-medium flex-1" :class="textClass">
            {{ message }}
        </p>
    </div>
</template>

<script>
export default {
    name: "BaseMessageInformation",
    props: {
        type: {
            type: String,
            default: "default", // Tipe pesan, default ke gray
            validator: (value) =>
                ["info", "warning", "error", "success", "default"].includes(value),
        },
        message: {
            type: String,
            required: true, // Pesan yang akan ditampilkan
        },
    },
    computed: {
        // Tentukan class background berdasarkan tipe
        bgClass() {
            const classes = {
                info: "bg-blue-50",
                warning: "bg-yellow-50",
                error: "bg-red-50",
                success: "bg-green-50",
                default: "bg-gray-50",
            };
            return classes[this.type];
        },
        // Tentukan class border berdasarkan tipe
        borderClass() {
            const classes = {
                info: "border-blue-300",
                warning: "border-yellow-300",
                error: "border-red-300",
                success: "border-green-300",
                default: "border-gray-300",
            };
            return classes[this.type];
        },
        // Tentukan class icon berdasarkan tipe
        iconClass() {
            const classes = {
                info: "text-blue-500",
                warning: "text-yellow-500",
                error: "text-red-500",
                success: "text-green-500",
                default: "text-gray-500",
            };
            return classes[this.type];
        },
        // Tentukan ikon berdasarkan tipe
        icon() {
            const icons = {
                info: "mdi:information-outline",
                warning: "mdi:alert-outline",
                error: "mdi:alert-circle-outline",
                success: "mdi:check-circle-outline",
                default: "mdi:information-outline",
            };
            return icons[this.type];
        },
        // Tentukan class teks berdasarkan tipe
        textClass() {
            const classes = {
                info: "text-blue-800",
                warning: "text-yellow-800",
                error: "text-red-800",
                success: "text-green-800",
                default: "text-gray-800",
            };
            return classes[this.type];
            // return 'text-gray-600';
        },
    },
};
</script>